import { makeAutoObservable } from "mobx";
import AuthAPI from "../API/AuthAPI";
import axios from "axios";
import { API_URL } from "../http";
import PositionsAPI from "../API/PositionsAPI";

export default class Store {
    user = {};
    isAuth = false;
    isLoading = false;
    breadcrumbs=[];
    userInfo = {};
    calcSumm = 0;
    discount = 0;
    isDiscount = false;

    constructor() { makeAutoObservable(this); }

    setUser(user) { this.user = user; }
    setUserInfo(user) { this.userInfo = user; }
    setAuth(bool) { this.isAuth = bool; }
    setLoading(bool) { this.isLoading = bool; }
    setCalcSumm(value) { this.calcSumm = value ? value : 0; }
    setDiscountStatus(value) { this.userInfo.discountStatus = value ? value : false; }
    setDiscount(value) { this.userInfo.discount = value ? value : 0; }

    async login(email, password) {
        try {
            const response = await AuthAPI.login(email, password);
            localStorage.setItem('token', response.data.accessToken);
            this.setAuth(true);
            this.setUser(response.data.user);

            return { error: false, response };
        } catch (err) {
            console.log("[login] error: ", err.response.data.message);
            return { error: true, response: err.response };
        }
    }

    async getPositionInfo(id) {
        try {
            if (!id) throw id;
            const response = await PositionsAPI.getInfo(id);
            return { error: false, response: response.data };
        } catch (err) {
            console.log("[getPositionInfo] error: ", err.response.data.message);
            return { error: true, response: err.response };
        }
    }

    async registration(email, name, surname, password) {
        try {
            const response = await AuthAPI.registration(email, name, surname, password);
            localStorage.setItem('token', response.data.accessToken);
            this.setAuth(true);
            this.setUser(response.data.user);

            return { error: false, response };
        } catch (err) {
            console.log("[registration] error: ", err.response.data.message);
            return { error: true, response: err.response };
        }
    }

    async logout() {
        try {
            await AuthAPI.logout();
            localStorage.removeItem('token');
            this.setAuth(false);
            this.setUser({});
        } catch (err) {
            console.log("[logout] error: ", err.message);
        }
    }

    async checkAuth() {        
        this.setLoading(true);
        try {
            const response = await axios.get(`${API_URL}/user/refresh`, { withCredentials: true });
            localStorage.setItem('token', response.data.accessToken);
            this.setAuth(true);
            this.setUser(response.data.user);
            // if (window.location.pathname != "/calc") window.location.replace("/calc");
        } catch (err) {
            console.log("[checkAuth] error: ", err.message)
        } finally {
            this.setLoading(false);
        }
    }
}